<template>
  <div class="-wt-mass-produce-upload">
    <input
      v-show="false"
      type="file"
      ref="file"
      @change="$_drop"
      accept=".csv"
    />
    <div class="-desc">
      Upload a data file for the videos you wish to create.
      <br />Then select any record to create a sample video.
    </div>
    <wt-files-dropzone
      ref="fileDrop"
      :number-of-files="1"
      :accept="acceptedMimes"
      :class="{ '-error': fileError }"
      :show="true"
    >
      <template slot="indicator">
        <i class="wticon wticon-upload2" />
        <span class="-drop-text wt2-text-m2">
          <template v-if="!fileError">Drop CSV file here</template>
          <template v-else>
            <template v-if="fileError == errors.WRONG_FILE_FORMAT">
              Wrong File Format
            </template>
            <template v-else> File Parse Error </template>
          </template>
        </span>
        <span class="-drop-desc wt2-link" @click="$refs.file.click()">
          or Browse
        </span>
      </template>
    </wt-files-dropzone>
    <div class="-drop-desc -download-csv wt2-link" @click="downloadSample">
      Download CSV sample
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      guid: app.guid('massproduce-modal'),
      isDragging: false,
    };
  },

  props: {
    onFileChange: {
      type: Function,
      required: true,
    },
    clearFileError: {
      type: Function,
      required: true,
    },
    fileError: {
      type: String,
      required: false,
    },
    acceptedMimes: {
      type: Array,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    storyboard: {
      type: Object,
      required: true,
    },
    linkedFields: {
      type: Object,
      required: true,
    },
  },

  created() {
    app.namespace.Util.FileDndDispatcher.add({
      guid: this.guid,
      handlers: {
        dragover: this.$_dragOver,
        dragenter: this.$_dragEnter,
        dragleave: this.$_dragLeave,
        drop: this.$_drop,
      },
    });
  },

  beforeDestroy() {
    app.namespace.Util.FileDndDispatcher.remove(this.guid);
  },

  methods: {
    downloadSample() {
      let csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += Object.keys(this.linkedFields).join(',');
      csvContent += '\n';
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      if (typeof link.download === 'string') {
        link.href = encodedUri;
        link.download =
          'Mass Produce Template - ' + this.storyboard.title + '.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(encodedUri);
      }
    },
    $_dragOver(e) {
      const dt = e.dataTransfer;
      if (dt.types && dt.types.indexOf('Files') >= 0) {
        this.clearFileError();
        e.preventDefault();
        e.stopPropagation();
        dt.dropEffect = 'copy';
      } else {
        this.isDragging = false;
      }
    },

    $_dragEnter: function (e) {
      e.preventDefault();
      if (e.fromElement === null) {
        this.isDragging = true;
      }
    },

    $_dragLeave: function (e) {
      e.preventDefault();
      if (e.fromElement === null) {
        this.isDragging = false;
      }
    },

    $_drop: function (e) {
      e.preventDefault();
      this.isDragging = false;
      this.$refs.fileDrop.active = false;
      const fileList = app.getFilesFromEvent(e);
      if (!fileList.length) {
        return;
      }
      const file = fileList[0];
      this.onFileChange(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.-wt-mass-produce-upload {
  height: 100%;
  display: flex;
  flex-direction: column;

  .-desc {
    width: 500px;
    margin-bottom: 20px;
  }
  .wt-files-dropzone {
    height: 100%;
    &.-error {
      .-drop-text {
        color: #d0021b;
      }
    }
    &.-active {
      &/deep/ {
        .wt-files-dropzone-border {
          border: 1px dashed #06a9f4;
        }
      }
    }
    &/deep/ {
      .wt-files-dropzone-border {
        margin: 0;
        padding: 0;
        height: 100%;
        border: 1px dashed #d9d9d9;
      }
      .wticon-upload2 {
        font-size: 30px;
        margin-bottom: 30px;
      }
      .-drop-text {
        margin-bottom: 10px;
      }
    }
  }

  .-download-csv {
    text-align: center;
    bottom: 50px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
>
